<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/material/inland',title:'订单管理'},{title:'服务类订单'}]"/>
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目名称</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="tableData" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine" ref="form1" :rules="rules">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-select v-model="tableData.orderProjectCode"
                                           placeholder="请选择" clearable filterable @change="getProjectInfo">
                                    <el-option v-for="item in allProjectByUser"
                                               :key="item.id"
                                               :label="item.projectName"
                                               :value="item.id">
                                        {{ item.projectName }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="PO单" class="h-elformWrap-2">
                                <el-input v-model="tableData.orderData.poId" placeholder="自带出"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="PO凭证" class="h-elformWrap-2">
                                <el-input v-model="tableData.orderData.orderMainContract" placeholder="自带出"></el-input>
                            </el-form-item> -->
							<el-form-item label="PO凭证" class="h-elformWrap-2" v-if="showPO">
							    <brupload :refid="tableData.id" reftype="服务类订单PO凭证" :showtime="false"></brupload>
							</el-form-item>
							<el-form-item label="上传PO凭证" class="h-elformWrap-2" v-if="!showPO">
							    <brupload :refid="tableData.id" :showtime="false"
							            reftype="服务类订单PO凭证"
							            uploadflag delflag></brupload>
							</el-form-item>
							<el-form-item label="订单类型" class="h-elformWrap-2">
							    <el-input v-model="xsqyStr" readonly></el-input>
							</el-form-item>
							<el-form-item label="销售公司" class="h-elformWrap-2">
							    <el-input v-model="xszzStr" readonly></el-input>
							</el-form-item>
							<el-form-item label="分销渠道" class="h-elformWrap-2">
								<el-input v-model="fxqdStr" readonly></el-input>
							</el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="tableData" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="售达方名称" class="h-elformWrap-2">
								<el-input v-model="tableData.orderData.soldToName" placeholder="请输入" @focus="openShoudf" readonly>
								    <i
										class="el-icon-search el-input__icon"
										slot="suffix"
										@click="openShoudf">
								    </i>
								</el-input>
                            </el-form-item>
                           <el-form-item label="联系人" class="h-elformWrap-2">
                              <el-input v-model="tableData.orderData.contactName" placeholder="请输入"></el-input>
                           </el-form-item>
						   <el-form-item label="联系电话" class="h-elformWrap-2">
						      <el-input v-model="tableData.orderData.firsttelephone" placeholder="请输入"></el-input>
						   </el-form-item>
						   <el-form-item label="计划发货日" class="h-elformWrap-2">
						      <div class="block">
						          <el-date-picker
						                  v-model="tableData.orderData.receivedTime"
						                  type="date"
										  value-format="yyyy-MM-dd"
										  :picker-options="pickerOptions"
						                  placeholder="--选择--"
						                  :clearable=false>
						          </el-date-picker>
						      </div>
						   </el-form-item>
						   <el-form-item label="客户地址" class="h-elformWrap-2">
						      <el-input v-model="c.toAddress" placeholder="请输入" @focus="handleIconClick" style="width: 500px;" clearable>
								  <i
										  class="el-icon-search el-input__icon"
										  slot="suffix"
										  @click="handleIconClick">
								  </i>
							  </el-input>
						   </el-form-item>
                           
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">
					项目产品信息
					<el-select v-model="productType" placeholder="请先选择产品类型" style="padding-left: 20px;" clearable>
						<el-option v-for="item in productTypes" :key="item.index" :value="item.value" :label="item.value"></el-option>
					</el-select>
				</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                    type="selection"
                    width="70"
                    label="全选"
                    @change="getAllTotalPrice(multipleSelection)">
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="序号"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="materialCode"
                    label="物料编码"
                    width="180">
                    <template slot-scope="scope" v-show="showHidden">
                        <el-input v-model="scope.row.materialCode" @change="getSingleOrder(scope.row)" placeholder="请输入"
                            class="h-tableInput" :disabled="showHidden2">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proModelCode"
                    label="物料描述"
					:show-overflow-tooltip="true"
                    >
                </el-table-column>
                <el-table-column
                    prop="proNumber"
                    label="订单数量"
                    :rules="[
                                { required: true, message: '请输入排序名称'},
                                { type: 'number', message: '必须为数字值',trigger: 'blur'}
                            ]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @blur="getTotalPrice(scope.row)"
                            placeholder="请输入"
                            class="h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proBenchmarkPrice"
                    label="价格"
                    >
                </el-table-column>
                <el-table-column
                    prop="specialPrice"
                    label="特价"
                    >
                </el-table-column>
                
                <el-table-column
                    prop="totalPrice"
                    label="合计金额"
                    >
                </el-table-column>
                <!-- <el-table-column
                    prop="finalPrice"
                    label="佣金"
                   >
                </el-table-column> -->
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.id"
                                @click="deleteThis(scope.row.id)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox" style="justify-content: initial;">
							<span class="l-operationlist br-operation-delete" style="margin-top: 0.2rem;" title="删除" @click="deleteThis(scope.row.id)"></span>
						</div> -->
                    </template>
                </el-table-column>
              
            </el-table>
            <div style="background-color: rgb(94, 182, 233);" v-if="showHidden" @click="showProcuct">
                <img src="../../../assets/images/pimg/jiahao.png" alt="">
            </div>
            <div class="jieguo">
                <span class="bizhong">币种</span>
                <span class="renminbi">{{ currency }}</span>
                <span class="dingdan">订单总价</span>
                <span class="yuan">{{ allTotalPrice }}</span>
                <span class="xianjin">现金余额</span>
                <span class="money">{{ cashBalance }}</span>
                <span class="xianjin">现金占用</span>
                <span class="money">{{ cashOccupy }}</span>
                <span class="xianjin">信贷余额</span>
                <span class="zhangqi">{{ creditBalance }}</span>
                <span class="xianjin">信贷占用</span>
                <span class="zhangqi">{{ creditOccupy }}</span>
                <span class="jiazhi">净价值</span>
                <span class="make">{{n.netPrice}}</span>
            </div>
        </div>
        <div class="anniu">
            <el-row>
                <a href="/dingd/material/inland">
                    <el-button class="quxiao" style="margin-right:10px;" @click="jump">取消</el-button>
                </a>
                <el-button class="zancun" @click="createNewOrder(10)">暂存</el-button>
                <el-button class="queren" @click="createNewOrder(20)">确认提交</el-button>
            </el-row>
        </div>
        <!--售达方-->
        <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag
                :usercode="currentUser"
                title="选择售达方"/>
				<!-- 地址 -->
		<areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址" v-if="showflag"/>
		<!-- 单机 -->
		<wxwl :visible.sync="showdialog" v-if="showdialog" @choseObj="choseWuliao" :usercode="currentUser"
		      title="选择物料"/>
		<!-- 套机-->
		<taoji :visible.sync="showdialog2" v-if="showdialog2" @choseObj="choseTaoji" :usercode="currentUser" 
			:agentLevel="agentLevel" title="选择物料"></taoji>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import big from 'big.js'
	import wxwl from '../../../components/dialog/wxwl'
	import areaSelect from '../../../components/areaSelect'
	import shoudf from '../../../components/dialog/selectshdf'
	import taoji from '../../../components/dialog/wxwl-fuwu'

    export default {
		components: {
		    wxwl,
			areaSelect,
			shoudf,
			taoji
		},

        //页面加载前事件
        created() {
          this.projectManagePage();
		  this.queryMoney();
		  // this.queryXiangmu();
		  this.setAppendix();
		  this.param = this.$route.query;
		  this.tableData.orderData.saleGroupCode = this.param.saleGroupCode;
		  this.tableData.orderData.disChannelCode = this.param.disChannelCode;
		  // 销售区域
		  this.xsqyStr = this.$store.getters.dictname("xiaoshou_quyu", this.param.orderCategory);
		  //内销
		  if (this.param.orderCategory == '1') {
		      this.xsqyStr = this.xsqyStr + "/" + this.$store.getters.dictname("xiaoshou_quyu_nx", this.param.orderCategory1);
		      //    外销
		  } else if (this.param.orderCategory == '2') {
		      this.xsqyStr = this.xsqyStr + "/" + this.$store.getters.dictname("xiaoshou_quyu_wx", this.param.orderCategory1);
		  }
		  //销售组织
		  this.xszzStr = this.$store.getters.dictname("YLSalesOrganization_agent", this.param.saleGroupCode);
		  
		  // 分销渠道
		  this.fxqdStr = this.$store.getters.dictname("fenxiao_qudao", this.param.disChannelCode);
		  if (this.param.disChannelCode == 'Z1') {
		      this.fxqdStr = this.fxqdStr + this.$store.getters.dictname("fenxiao_qudao_shanghai", this.param.zCode);
		  }
        },

        methods: {
			choseTaoji(attr){
				var list = attr[0].componentList;
				for(var i=0;i<list.length;i++){
					var obj = list[i];
					this.currency = obj.currency;
					var data = {
						id:this.$util.getUuid(),
						materialCode:obj.matecode,
						proModelCode:obj.matedes,
						proBenchmarkPrice:obj.jizhj,
						totalPrice:0
					}
					this.tableData2.push(data);
				}
				this.showdialog2 = false;
			},
			//附件展示与上传控制
			setAppendix() {
			    if (this.tableData.poId != null && this.tableData.poId != '') {
			        this.showPO = true;
			    }
			},
			//删除该行项目产品信息
			deleteThis(x) {
			    this.tableData2 = _.reject(this.tableData2, {'id': x});
			},
			choseshoudf(obj) {
			    this.tableData.orderData.soldToName = obj.username;
			    this.tableData.orderData.soldToCode = obj.usercode;
			    this.tableData.orderData.soldToAreaCode = obj.areaname;
				ss.UserService.selectAgentSell({usercode:obj.usercode}).then(rd=>{
					this.agentLevel = rd.obj.customerGroup;
					console.log(this.agentLevel)
				})
			    this.showshdfdialog = false
			},
			//选择售达方
			openShoudf() {
			    this.showshdfdialog = true;
			},
			//勾选事件
			handleSelectionChange(val) {
			    this.multipleSelection = val;
			    this.getAllTotalPrice(val);
			},
			//区域选择
			choseObj(obj) {
			    this.c.toAddress = obj.zhenobj.namepath + '/' + obj.addrdetail;
			
			    this.c.toProvincesCode = obj.shengobj.name;
			    this.c.toCityCode = obj.shiobj.name;
			
			    this.c.addressCode = obj.id;
			
			    this.showflag = false;
			},
			//跳转页面
			jump() {
			    this.$router.push({path: "/dingd/myOrderList"})
			},
			getProjectInfo(x){
				this.allProjectByUser.forEach((item, index) => {
				    if (item.id == x) {
				        this.tableData.projectName = item.projectName;
				        this.tableData.orderData.poId = item.poId;
				    }
				})
			},
			//计算每行成交价
			getFinalPrice(x) {
			    if (x == null) {
			        return;
			    }
			    x.forEach((item, index) => {
			        var c = 0;
			        if (item.specialPrice > 0) {
			            c = new big(item.specialPrice).plus(item.extraPrice);
			        } else {
			            c = new big(item.finalPrice).plus(item.extraPrice);
			        }
			        item.finalPrice = c.toString();
			    })
			    this.tableData2 = x;
			},
			//计算每行总价
			getETotalPrice(x) {
			    if (x == null) {
			        return;
			    }
			    x.forEach((item, index) => {
			        item.totalPrice = new big(item.proNumber).times(item.finalPrice).toString();
			    })
			    this.tableData2 = x;
			    this.getAllTotalPrice(this.tableData2);
			},
			//数量改变-总价改变
			getTotalPrice(n) {
			    var c = n.proBenchmarkPrice;
			    n.proNumber = n.proNumber == '' ? 0 : n.proNumber;
			    n.totalPrice = new big(n.proNumber).times(c);
			    n.totalPrice = (n.totalPrice).toString();
			    this.getAllTotalPrice(n);
			},
			
			//总价总和改变
			getAllTotalPrice() {
			    this.allTotalPrice = 0;
			    var aaa = 0;
			    var bbb = 0;
			    this.tableData2.forEach(function (val, index) {
			        aaa = new big(aaa).plus(val.totalPrice);
			    })
			    big.DP = 2;
			    bbb = new big(aaa).div(1.3);
			    this.allTotalPrice = aaa.toString();
			    this.n.netPrice = bbb.toString();
			    this.showMeYourMoney();
			},
			//自行添加一行产品信息
			getSingleOrder(x) {
			    ss.OrderService.getSingleOrder(x).then(rd => {
			        x.proModelCode = rd.proModelCode;
			        x.proBenchmarkPrice = rd.proBenchmarkPrice;
			        x.finalPrice = rd.proBenchmarkPrice;
			        this.getTotalPrice(x);
			    });
			},
			//获取该项目下所有产品行
			queryXiangmu() {
			    if (this.param.id == '') {
			        return;
			    }
			    ss.OrderService.getFilteredProductPage(this.param).then(rd => {
			        this.param.total = rd.total;
			        this.page = rd
			        this.tableData2 = rd.records;
			        this.param.orderSubContract = this.tableData2[0].orderSubContract;
			        this.getFinalPrice(this.tableData2);
			        this.getETotalPrice(this.tableData2);
			        //币种
			        var aaa = '';
			        this.tableData2.forEach(function (val, index) {
			            aaa = val.currencyCode;
			        })
			        this.currency = aaa;
			
			        this.queryCust(this.tableData2);
			    })
			
			
			    if (this.param.id == '') {
			        this.showHidden = true;
			        this.showHidden2 = false;
			    } else {
			        this.showHidden = false;
			        this.showHidden2 = true;
			    }
			
			    this.getAllTotalPrice();
			},
			choseWuliao(obj) {
			    obj = obj[0];
			
			    this.currency = obj.currency;
			    this.objectList.materialCode = obj.matecode;
			    this.objectList.proModelCode = obj.matedes;
			    this.objectList.proBenchmarkPrice = obj.jizhj;
			    this.objectList.specialPrice = obj.tejia;
			    // this.objectList.extraPrice = 100;
			
			    //最终价
			    // this.objectList.finalPrice = this.objectList.specialPrice == null ?
			    //     this.objectList.proBenchmarkPrice : this.objectList.specialPrice;
			
			    this.tableData2.push(this.objectList);
			    this.showdialog = false;
			},
			//创建新订单
			createNewOrder(p) {
			    var tableData111 = [];
			    this.tableData2.forEach(function (val, index) {
			        val.spare3 = val.spare3 == '否' ? 0 : 1;
			        tableData111.push(val);
			    })
			    this.tableData.orderProductList = tableData111;
			
			    // if (this.tableData.orderProductList.length < 1) {
			    //     this.$msg.msge('订单提交失败,请先选择订单产品!');
			    //     return;
			    // }
			    this.tableData.orderStatus = p;
			
			    this.tableData.addressCode = this.c.addressCode;
			    this.tableData.creditId = this.n.id;
			    
			    this.tableData.orderData.orderNetWorth = this.n.netPrice;
			    
			    this.tableData.orderData.currencyCode = this.currency;
			    this.tableData.orderCategory1 = this.param.orderCategory1;
			    this.tableData.orderData.saleGroupCode = this.param.saleGroupCode;
			    this.tableData.orderData.disChannelCode = this.param.disChannelCode;
			    this.tableData.orderData.toAddress = this.c.toAddress;
			    this.tableData.orderData.isStockUp = this.c.isStockUp;
			
			    this.tableData.orderData.toProvincesCode = this.c.toProvincesCode;
			    this.tableData.orderData.toCityCode = this.c.toCityCode;
			
			    //TODO 地区编码
			    this.tableData.orderData.regionCode = this.c.regionCode;
			    //配送中心
			    this.tableData.orderData.dcCode = this.c.regionCode;
				console.log(this.tableData)
			    ss.OrderService.createNewOrder(this.tableData).then(rd => {
			        this.$msg.msgs(rd.msg);
			        this.jump();
			    });
			},
			//下单金额扣除
			showMeYourMoney() {
			    this.cashOccupy = this.creditOccupy = 0;
			    if (this.allTotalPrice <= this.cashBalance) {
			        //现金足够扣现金
			        this.cashOccupy = this.allTotalPrice;
			        //现金不足扣信贷
			    } else if (this.allTotalPrice > this.cashBalance) {
			        //现金全部扣完
			        this.cashOccupy = this.cashBalance;
			        //剩余部分扣信贷
			        this.creditOccupy = this.allTotalPrice - this.cashBalance;
			    }
			},
			//查询余额
			queryMoney() {
			    ss.OrderService.queryMoney().then(rd => {
			        this.cashBalance = rd.obj.cashBalance;
			        this.creditBalance = rd.obj.creditBalance;
			    });
			},
			//获取当前用户所有项目详情
			projectManagePage() {
			    ss.OrderService.projectManagePage().then(rd => {
			        this.allProjectByUser = rd;
			    });
			},
            showProcuct(){
				if(this.productType == "单机") {
					this.showdialog = true;
				}else if(this.productType == "套机"){
					if(this.agentLevel==null || this.agentLevel==""){
						this.$msg.msge("请先选择售达方");
						return;
					}
					this.showdialog2 = true;
				}else{
					this.$msg.msge("请先选择产品类型");
					return;
				}
				this.currentUser = this.tableData.orderData.soldToCode == null ? this._user.usercode : this.tableData.orderData.soldToCode;
				this.objectList = {
				    id: '',
				    materialCode: '',
				    proModelCode: '',
				    proNumber: '',
				    proBenchmarkPrice: '',
				    specialPrice: '',
				    isStockUp: '',
				    spare3: '',
				    extraPrice: '',
				    finalPrice: '',
				    totalPrice: '',
				}
				// this.objectList.id = this.$util.getUuid();
			},
			handleIconClick() {
			    this.showflag = true;
			},
            mounted() {
                //  this.queryXiangmu();
            },
        },

        data() {
            return {
				agentLevel:"",
				productTypes:[{value:"单机"},{value:"套机"}],
				productType:"",
				showPO:false,
				showshdfdialog:false,
				//销售渠道，销售组织，分销渠道
				xsqyStr: '',
				xszzStr: '',
				fxqdStr: '',
				objectList: {},
				c: {
				    addressCode: '',
				    isStockUp: '',
				    soldToAreaCode: '',
				    customerChannelCode: '',
				    contactName: '',
				    receivedTime: '',
				    toAddress: '',
				    firsttelephone: '',
				},
				showflag:false,
				optionsCustomer:"",
				param:"",
				currentUser: null,
				showdialog:false,
				showdialog2:false,
				rules:{
					orderProjectCode: [
				    	{ required: true, message: '请输入关联项目编码', trigger: 'blur' },
					],
				},
                showHidden: true,
                showHidden2: false,
                objectName: '',
                //分销渠道
                options: [{
                    value: '00',
                    label: '通用分销渠道'
                }, {
                    value: 'X1',
                    label: '香港外销渠道'
                }, {
                    value: 'Z1',
                    label: '上海直销渠道',
                    children: [{
                        value: 'ZSH1',
                        label: '采购本部',
                    }, {
                        value: 'ZSH2',
                        label: '第三方采购',
                    }, {
                        value: 'ZSH3',
                        label: '第三方销售',
                    }],
                }],

                //sap订单参数
                orderCategory: '',


                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                cflag: false,
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currency: '',
                multipleSelection: [],
                //创建订单数据
                tableData: {
                    orderStatus: 1,
                    orderProjectCode: '',
                    orderData: {
                        currencyCode: '',
                        orderCategory: '1',
                        saleGroupCode: '',
                        disChannelCode: '',
                        zCode: '',
                    },
                    orderProductList: [],
                },
                tableData2: [],
                //根据用户id查询出的所有项目
                allProjectByUser: [],
                clickActive: 1,
				n: {
				    netPrice: '',
				    quota: '',
				    id: '',
				    paymentdate: '',
				},

                
            };
        },
    }

</script>

<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }
    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {
        width: 100px;
    }

    .bizhong, 
    .dingdan,
    .xianjin, 
    .jiazhi{
        width: 8%;
        text-align: center;
    }
    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .renminbi, .yuan, .money, .zhangqi, .make{
        width: 10%;
        text-align: center;
       

    }
    .bizhong,
    .renminbi,
    .dingdan,
    .xianjin,
	.money,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding:10px 0;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
        margin-top: 12px;
        width: 100%;
        padding-right: 20px;
       
    }
    span {
        color: white;
        position: relative;
        top: -12px;
        left: 20px;
        font-size: 14px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }
    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .bbbb {
        margin: 20px 20px 0 20px;
    }

    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }

</style>
